import { Location } from '@angular/common';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@app/auth/authentication.service';

/**
 * Router guard to check if user is logged in or not.
 */

export const authGuard = () => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);
    const location = inject(Location);

    const currentUser = authService.currentUser();
    if (currentUser === null) {
        // If user is missing, fetch the current user before allowing navigation.
        return authService.fetchAndStoreUserDetails().pipe(
            catchError(error => {
                if (
                    error instanceof HttpErrorResponse &&
                    error.status === HttpStatusCode.Unauthorized.valueOf()
                ) {
                    router.navigate(['/logout'], {
                        queryParams: { returnUrl: location.path(true), action: 'login' },
                    });
                }

                return of(false);
            }),
        );
    }

    return of(!!currentUser);
};
